<script>
import { authComputed, authMethods } from '@state/helpers'
import layout from '@src/mixins/layout.vue'
import { authService } from '@/src/services/safehaven/AuthService'

export default {
  mixins: [layout],
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    name: {
      type: String,
      default: 'User',
    },
    orgId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      slides: null,
      stepNo: 0,
      show: {
        arrows: true,
        nextArrow: 'md-arrow-right',
      },
    }
  },
  computed: {
    ...authComputed,
    user() {
      return this.serializedUser
    },
    desktopSlides() {
      return this.slides.filter((el) => !el.mobileOnly)
    },
  },
  watch: {
    stepNo: function(newStep, oldStep) {
      // some logic here, for example
      this.nextArrow = newStep === 4 ? 'md-arrow-right' : false
    },
  },
  mounted() {
    authService.getWelcomeDetails(this.orgId).then((res) => {
      this.slides = res.data
    })
  },
  methods: {
    ...authMethods,
    async getStartedHandler() {
      await this.updateUserSettings({ welcomed: true })
      this.$emit('update:value', false)
      this.$router.push({ name: 'safehaven-dashboard' })
    },
    onClickHandler(index) {
      const attrs = this.slides.length + 1
      const attr = attrs[index]
      this.$emit('changeValue', attr)
    },
  },
}
</script>

<template>
  <v-dialog
    :value="value"
    persistent
    no-click-animation
    min-width="300px"
    max-width="800px"
    transition="fade-transition"
    :content-class="'elevation-0' + ' ' + $style.dialogMenu"
    :fullscreen="mobile"
  >
    <v-card class="py-8">
      <v-card-text>
        <template>
          <v-carousel
            ref="carousel"
            v-model="stepNo"
            hide-delimiter-background
            show-arrows-on-hover
            :continuous="false"
            height="685"
            :class="$style.mobileheight"
            :show-arrows="false"
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
              data-test="welcome"
            >
              <v-sheet height="100%">
                <v-row class="fill-height" align="center" justify="center">
                  <div :class="$style.textInner">
                    <div :class="$style.carouselContent">
                      <h2
                        >{{ slide.message_title }}
                        <span v-if="i === 0">{{ user.first_name }}!</span></h2
                      >
                      <v-row no-gutters justify="center">
                        <v-img
                          contain
                          :src="slide.image_url"
                          :class="$style.imageClass"
                        />
                      </v-row>
                      <p>{{ slide.message_description }}</p>
                      <div v-if="i === slides.length - 1">
                        <v-btn
                          class="text-capitalize"
                          rounded
                          color="primary"
                          :class="$style.btnClassMobile"
                          @click="getStartedHandler"
                        >
                          Get Started
                        </v-btn>
                      </div>

                      <div v-else>
                        <v-btn
                          v-if="!notDesktop"
                          color="primary"
                          :class="$style.btnClassnext"
                          @click.stop="$refs.carousel.next"
                          >Next</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  border-radius: 9px !important;
}

.title {
  font-size: 32px !important;
  font-weight: 400;
  line-height: 42px;
  color: #505050;
  text-align: center;
  letter-spacing: 0;
}

.subTitle {
  font-size: 16px !important;
  font-weight: 400;
  line-height: 30px;
  color: #2c3a4b !important;
  text-align: center;
  letter-spacing: 0;
}

.subTitleContainer {
  top: 0;
  left: 0;
  max-width: 878px;
  max-height: 76px;
}

.cardImage {
  top: 19.5888671875px;
  left: 0;
  max-width: 227.4439239501953px;
  max-height: 187.56544494628906px;
  border-radius: 0;
}

.cardContainer {
  top: 0;
  left: 0;
  width: 324px;
  height: 191px;
  margin-top: 20px;
}

.mainContainer img {
  top: 19.5888671875px;
  left: 0;
  max-width: 227.4439239501953px;
  max-height: 187.56544494628906px;
  border-radius: 0;
}

.cardContainer h2 {
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  text-align: center;
  letter-spacing: 0;
}

.cardContainer p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #505050;
  text-align: center;
  letter-spacing: 0;
}

.mainContainer {
  align-items: center;
  justify-content: center;
}

.btnClass {
  font-size: 22px;
  font-weight: 600;
  line-height: 33px;
  text-align: center;
  letter-spacing: 0;
  border-radius: 32px;
}

.textInner {
  width: 100%;
  max-width: 660px;
  padding: 0 20px;
  margin: 0 auto;
}

.imageClass {
  top: 30px;
  left: 0.00048828125px;
  width: 300px;
  height: 250px;
}

.carouselContent {
  max-width: 100%;
  overflow: hidden;
  text-align: center;
}

.carouselContent h2 {
  font-size: 28px;
  font-weight: 400;
  line-height: 38px;
  color: #09101d;
  text-align: center;
  letter-spacing: -0.30000001192092896px;
}
.carouselContent p {
  margin-top: 65px;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  color: #2c3a4b;
  text-align: center;
  letter-spacing: 0;
}
.btnClassMobile {
  width: 310px !important;
  height: 51px !important;
  padding: 14px, 18px, 14px, 18px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 21px !important;
  font-weight: 600 !important;
  line-height: 33px !important;
  color: #fff !important;
  text-align: center !important;
  text-decoration: none;
  letter-spacing: 0;
  background-color: #0476d9;
  border-radius: 32px;
}
.btnClassnext {
  width: 200px !important;
  height: 51px !important;
  padding: 14px, 18px, 14px, 18px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 21px !important;
  font-weight: 600 !important;
  line-height: 33px !important;
  color: #fff !important;
  text-align: center !important;
  text-decoration: none;
  text-transform: capitalize;
  letter-spacing: 0;
  background-color: #0476d9;
  border-radius: 32px;
}
@media screen and (max-width: 599px) {
  .mobileheight {
    height: 800px !important;
  }
}
</style>
